<template>
  <canvas class="audio-visualizer" :width="width" :height="height" />
</template>

<script>
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export default {
  props: {
    frequencies: {
      type: Array,
      default() {
        return []
      },
    },
    backgroundColor: {
      type: String,
      default: '#F8F8F8',
    },
    barColor: {
      type: String,
      default: '#FEC006',
    },
    width: {
      type: Number,
      default: 480,
    },
    height: {
      type: Number,
      default: 480,
    },
  },
  data() {
    return {
      drawing: false,
    }
  },
  watch: {
    frequencies() {
      this.redrawOnNextFrame()
    },
    backgroundColor() {
      this.redrawOnNextFrame()
    },
    barColor() {
      this.redrawOnNextFrame()
    },
  },
  mounted() {
    this.redrawOnNextFrame()
  },
  methods: {
    redrawOnNextFrame() {
      if (this.drawing) {
        return
      }
      this.drawing = true
      window.requestAnimationFrame(this.redraw.bind(this))
    },
    redraw() {
      const canvas = this.$el
      const context = canvas.getContext('2d')
      const heightMultiple = canvas.height / 255

      context.fillStyle = this.backgroundColor
      context.fillRect(0, 0, canvas.width, canvas.height)

      // context.canvas.width = canvas.offsetWidth
      // context.canvas.height = canvas.offsetHeight

      const lineTo = context.canvas.height
      context.strokeStyle = this.barColor
      context.lineWidth = 3
      context.lineJoin = 'round'
      let drawX = 1

      for (const volume of this.frequencies) {
        const barHeight = volume * heightMultiple
        const lineFrom = Math.floor(lineTo - barHeight)
        context.beginPath()
        context.moveTo(drawX, lineFrom)
        context.lineTo(drawX, lineTo)
        context.closePath()
        context.stroke()
        drawX += 4
      }

      this.drawing = false
    },
  },
}

// watch: {
//   currentVolume(newVolume) {
//     if(this.drawing) {
//       return;
//     }
//     this.drawing = true

//     if(this.recording) {
//       window.requestAnimationFrame(() =
//         this.resetCanvas()
//         const canvas = this.$refs.canvas
//         const context = canvas.getContext('2d')
//         const halfWidth = 320
//         const halfHeight = 240
//         context.beginPath()
//         context.moveTo(halfWidth, 0)
//         context.lineTo(halfWidth, canvas.height)
//         context.closePath()
//         context.strokeStyle = "red"
//         context.lineWidth = 1
//         context.stroke()

//         context.strokeStyle = "white"
//         context.lineWidth = 2
//         context.lineJoin = "round"
//         const barsToUse = this.volumeBars.slice(-64)
//         let drawX = halfWidth - (barsToUse.length*5)
//         for(let volume of barsToUse) {
//           const barHeight = (volume*10) + 1
//           const lineFrom = Math.floor(halfHeight-barHeight/2)
//           const lineTo = Math.ceil(halfHeight+barHeight/2)
//           context.beginPath()
//           context.moveTo(drawX, lineFrom)
//           context.lineTo(drawX, lineTo)
//           context.closePath()
//           context.stroke()
//           drawX += 5
//         }
//         this.drawing = false
//       })
//     }
//   }
// },
</script>

<style scoped>
canvas {
  display: block;
}
</style>
